import { service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';

export default class Footer extends Component {
  @service intl;
  @service url;

  get currentYear() {
    const currentYear = new Date().getFullYear();
    return this.intl.t('navigation.footer.current-year', { currentYear });
  }

  get legalNoticeUrl() {
    return this.url.legalNoticeUrl;
  }

  get accessibilityUrl() {
    return this.url.accessibilityUrl;
  }

  get serverStatusUrl() {
    return this.url.serverStatusUrl;
  }

  <template>
    <footer class='footer'>
      <nav class='footer__navigation' aria-label={{t 'navigation.footer.aria-label'}}>
        <ul class='footer__navigation-list'>
          <li>
            <a href={{this.legalNoticeUrl}} target='_blank' class='footer-navigation__item' rel='noopener noreferrer'>
              {{t 'navigation.footer.legal-notice'}}
              <span class='sr-only'>{{t 'common.a11y.external-link'}}</span>
            </a>
          </li>

          <li>
            <a href={{this.accessibilityUrl}} target='_blank' class='footer-navigation__item' rel='noopener noreferrer'>
              {{t 'navigation.footer.a11y'}}
              <span class='sr-only'>{{t 'common.a11y.external-link'}}</span>
            </a>
          </li>

          <li>
            <a href={{this.serverStatusUrl}} target='_blank' class='footer-navigation__item' rel='noopener noreferrer'>
              {{t 'navigation.footer.status'}}
              <span class='sr-only'>{{t 'common.a11y.external-link'}}</span>
            </a>
          </li>
        </ul>
      </nav>

      <div class='footer__copyright'>
        <span>{{this.currentYear}}</span>
      </div>
    </footer>
  </template>
}
